/* src/app/views/admin/doctors/doctor-info/doctor-info.component.css */
input#file {
  display: none;
}
.btn-upload {
  padding-right: 12px;
  padding-left: 13px;
  top: -45px;
  left: -80px;
  position: relative;
}
::ng-deep .ngx-ic-source-image {
  display: inline-grid !important;
}
/*# sourceMappingURL=doctor-info.component.css.map */
